import Reflux from 'reflux-react-16'

export default Reflux.createActions([
    'setView',
    'setDates',
    'setTimes',
    'setQueries',
    'setSelected',

    'get',
    'getOne',
    'getRecentCustomerOrders',
    'create',
    'edit',
    'getTemplate',
    'getTemplates',
    'editTemplate',

    'editInfo',
    'editDate',
    'editAddress',
    'editBranch',
    'editCollo',
    'editAdministration',
    'editMoreOptions',

    'addOptions',
    'remove',
    'recalculateDeliveryZoneIds',
    'removeTemplate',
    'printLabels',
    'getPrice',
    'addHistoryComment',
    'editColloStatus',
    'complete',
    'atHub',
    'reschedule',
    'sendToPartner',
    'onHold',
    'notSupplied',
    'manco',
    'pickup',
    'deliver',
    'getNotPossibleReasons',
    'sendRetour',
    'cancelRetour',
    'newRoute',
    'updateRoute',
    'rescheduleRoute',
    'removeRoute',
    'addToRoute',
    'planRoute',
    'stopRoute',
    'setRouteReady',
    'setRouteLocked',
    'setAddressLocked',
    'setRouteAnchoring',
    'createPlanning',
    'getRouteTemplate',
    'getRouteTemplates',
    'createRouteTemplate',
    'updateRouteTemplate',
    'removeRouteTemplates',

    'changeTimeslot',
    'check',
    'sendDeliveryMail',

    'findByBarcode',
    'scan',

    'resetRoutesHidden',
    'setRouteHidden',
    'setRouteLoading',
    'setRouteFocus',
    'setActiveRouteTab',
    'setSelectedRoute',
    'setMapOptions',
    'setMapView',
    'setShowRoutePanel',
    'setShowOrderPanel',
    'setShowOrdersOnMap',
    'setShowCompletedAddresses',
    'setShowRoutesOnMap',
    'setShowStopNumbersOnMap',

    'clearError',
    'getFile'

])
